<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Add copyright owner</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <CopyrightOwnerTypeSelection v-model="type" class="mb-[14px]" />

      <Input
        v-if="isPersonal"
        v-model="name"
        size="xl"
        :label="label"
        :disabled="loading"
      />

      <OrganizationSearch
        v-else
        v-model="selectedOrg"
        :label="label"
        :disabled="loading"
        @update:query="handleNameUpdate"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import CopyrightOwnerTypeSelection from '@/features/copyright/components/CopyrightOwnerTypeSelection.vue'
import OrganizationSearch from '@/features/search/components/OrganizationSearch.vue'
import { useNewCopyrightOwner } from './useNewCopyrightOwner'

const { close } = useSheet()
const {
  name,
  selectedOrg,
  type,
  isPersonal,
  label,
  loading,
  handleNameUpdate,
  save,
} = useNewCopyrightOwner()

const handleSave = async () => {
  await save()
  close()
}
</script>
